<template>
	<div class="merchant_content">
		<div class="merchant_wrap">
			<h3 class="user">
				{{ $store.state.auth.member_info.user_name }}
				{{ $t('merchant_management.merchant_list') }}
			</h3>
			<div v-if="isShowList" class="merchant_list">
				<div v-for="item in merchantList" :key="item.seq" class="merchant_item">
					<div class="box_item">
						<p>{{ $t('merchant.picker.merchant_name') }}</p>
						<p class="shop_name">{{ item.merchant_name }}</p>
					</div>
					<div class="box_item">
						<p>{{ $t('merchant.picker.merchant_id') }}</p>
						<p class="shop_id">{{ item.merchant_id }}</p>
					</div>
					<div class="box_item">
						<p>{{ $t('merchant.picker.regist_date') }}</p>
						<p>{{ $dayjs(item.regdate).format('YYYY.MM.DD') }}</p>
					</div>
					<div class="d_flex justify_end">
						<a class="link_button" @click="onManagement(item)">
							<span class="icon_card"></span>
							<p>{{ $t('merchant.settlement.title') }}</p>
						</a>
					</div>
				</div>
				<div class="tac mt_20 mb_20">
					<a @click="registModal = true">
						<span class="icon_add-shop"></span>
						<p>{{ $t('merchant.picker.title2') }}</p>
					</a>
				</div>
			</div>

			<div v-if="!isShowList" class="settlement_list">
				<div class="detail_title" @click="back">
					<span class="icon LEFTARROW mr_8"></span>
					<h3 class="title_s">{{ $t('merchant.settlement.title') }}</h3>
				</div>
				<div>
					<div class="selected_merchant">
						<div class="box_item">
							<p>{{ $t('merchant.picker.merchant_name') }}</p>
							<p class="shop_name">
								{{ selectedMerchantInfo.merchant_name }}
							</p>
						</div>
						<div class="box_item">
							<p>{{ $t('merchant.picker.merchant_id') }}</p>
							<p class="shop_id">
								{{ selectedMerchantInfo.merchant_id }}
							</p>
						</div>
					</div>

					<div v-if="settlementAccounts.length > 0">
						<div
							v-for="item in settlementAccounts"
							:key="item.seq"
							class="merchant_item"
						>
							<div class="box_item">
								<p>{{ $t('merchant.settlement.asset_name') }}</p>
								<p class="shop_name">
									{{ item.asset_code }} {{ item.asset_title }}
								</p>
							</div>
							<div class="box_item">
								<p>{{ $t('merchant_management.account_number') }}</p>
								<p class="shop_id">{{ item.account_number }}</p>
							</div>
							<div class="box_item">
								<p>{{ $t('merchant.settlement.date') }}</p>
								<p>{{ $dayjs(item.regdate).format('YYYY.MM.DD') }}</p>
							</div>
							<div class="d_flex justify_end">
								<a class="link_button type1" @click="onDisconnect(item)">
									<span class="icon_card"></span>
									<p>{{ $t('merchant.settlement.set_disconnect') }}</p>
								</a>
							</div>
						</div>
					</div>

					<div v-else>
						<div class="list_none tac">
							<span class="ERRORGRAY mb_4"></span>
							<div class="fc_gray2">
								{{ $t('merchant.settlement.no_content') }}
							</div>
						</div>
					</div>
					<div class="tac mt_20 mb_20">
						<a @click="settlementConnectModal = true">
							<span class="icon_add-shop"></span>
							<p>{{ $t('merchant.settlement.title1') }}</p>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- 가맹점 등록 모달 -->
	<ModalViewM v-if="registModal" @closeModal="registModal = false">
		<template #title>
			<h3 class="modal_title_m">{{ $t('merchant.picker.title2') }}</h3>
		</template>
		<div>
			<div class="mb_16 tal">
				<p class="mb_8">{{ $t('merchant.picker.merchant_name') }}</p>
				<div>
					<input type="text" v-model="merchantName" />
				</div>
			</div>
			<div class="tal">
				<p class="mb_8">{{ $t('merchant.picker.merchant_id') }}</p>
				<div>
					<input type="text" v-model="merchantId" />
				</div>
			</div>
			<button class="button_round button_bg_red mt_40" @click="createMerchant">
				{{ $t('button.register') }}
			</button>
		</div>
	</ModalViewM>
	<!--  정산 계좌 연결 모달 -->
	<ModalViewM
		v-if="settlementConnectModal"
		@closeModal="settlementConnectModal = false"
	>
		<template #title>
			<h3 class="modal_title_m">
				{{ $t('merchant.settlement.title1') }}
			</h3>
		</template>
		<SettlementAccountRegister
			@closeModal="settlementConnectModal = false"
			@successRegist="successRegist"
			:selectedMerchantInfo="selectedMerchantInfo"
		></SettlementAccountRegister>
	</ModalViewM>
	<!-- 정산 계좌 연결 해지 모달 -->
	<ModalViewM
		v-if="settlementDisconnectModal"
		@closeModal="settlementDisconnectModal = false"
	>
		<template #title>
			<h3 class="modal_title_m">
				{{ $t('merchant.settlement.title2') }}
			</h3>
		</template>
		<SettlementAccountDisconnect
			@successDisconnect="successDisconnect"
			:manage-merchant-info="selectedMerchantInfo"
			:disconnect-info="disConnectInfo"
		></SettlementAccountDisconnect>
	</ModalViewM>
	<!-- 메시지 모달 -->
	<ModalMessageM v-if="messageModal" @closeModal="messageModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="status_text">{{ modalStatusMessage }}</p>
		<div v-if="messageModalMode === 'success'" class="button_area">
			<button class="button_round button_bg_red mt_40" @click="confirm">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
	</ModalMessageM>
</template>

<script>
import {
	createMerchant,
	fetchMerchantList,
	fetchMerchantAccountList,
} from '@/api/pg';
import { commonError } from '@/common/dialog';
import ModalMessageM from '@/components/Layout/ModalMessage.m';
import ModalViewM from '@/components/Layout/ModalView.m';
import SettlementAccountRegister from '@/components/Merchant/Settlement/SettlementAccountRegister';
import SettlementAccountDisconnect from '@/components/Merchant/Settlement/SettlementAccountDisconnect';

export default {
	name: 'MerchantManagement',
	components: {
		ModalViewM,
		ModalMessageM,
		SettlementAccountRegister,
		SettlementAccountDisconnect,
	},
	data() {
		return {
			settlementAccounts: [],
			merchantList: [],
			successModal: false,
			registModal: false,
			settlementConnectModal: false,
			settlementDisconnectModal: false,
			isShowList: true,
			merchantName: '',
			merchantId: '',
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
			messageModalMode: '',
			selectedMerchantInfo: '',
			disConnectInfo: {},
		};
	},
	computed: {
		currentRoute() {
			return this.$route.name;
		},
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.loadMerchantList();
		},
		async loadSettlementAccountList() {
			const { data } = await fetchMerchantAccountList(
				this.selectedMerchantInfo.seq,
			).catch(commonError);
			this.settlementAccounts = data;
		},
		async loadMerchantList() {
			const { data } = await fetchMerchantList({ no_paging: 1 }).catch(
				commonError,
			);
			this.merchantList = data;
		},
		async createMerchant() {
			if (!this.validations()) return;
			const params = {
				merchant_name: this.merchantName,
				merchant_id: this.merchantId,
			};
			await createMerchant(params)
				.then(() => {
					this.successCreate();
					this.registModal = false;
				})
				.catch(commonError);
		},
		validations() {
			if (!this.merchantName) {
				alert(this.$t('merchant.picker.insert_shop_name'));
				return false;
			}
			if (!this.merchantId) {
				alert(this.$t('merchant.picker.insert_shop_id'));
				return false;
			}
			return true;
		},
		confirm() {
			this.messageModal = false;
		},
		back() {
			this.isShowList = true;
		},
		async onManagement(merchantInfo) {
			this.selectedMerchantInfo = merchantInfo;
			await this.loadSettlementAccountList(this.selectedMerchantInfo.seq).then(
				() => {
					this.isShowList = false;
				},
			);
		},
		onDisconnect(accountInfo) {
			this.disConnectInfo = accountInfo;
			this.settlementDisconnectModal = true;
		},
		successCreate() {
			this.modalStatusMessage = this.$t(
				'modal.message.merchant_regist_confirm',
			);
			this.modalIcon = 'success';
			this.messageModalMode = 'success';
			this.messageModal = true;
			this.loadMerchantList();
		},
		successRegist() {
			this.loadSettlementAccountList();
			this.settlementConnectModal = false;
			this.modalStatusMessage = this.$t('modal.message.settlement_connect');
			this.modalIcon = 'success';
			this.messageModalMode = 'success';
			this.messageModal = true;
		},
		successDisconnect() {
			this.loadSettlementAccountList();
			this.settlementDisconnectModal = false;
			this.modalStatusMessage = this.$t('modal.message.settlement_disconnect2');
			this.modalIcon = 'success';
			this.messageModalMode = 'success';
			this.messageModal = true;
		},
	},
};
</script>

<style scoped></style>
